import { Charge, CreateChargeData, CreateChargeResponse } from '@xver/@types/charge';
import httpClient from '@xver/libs/axios';

const ENDPOINTS = {
    CREATE: '/v1/charges',
    GET: (sourceID: string) => `/v1/charges/${sourceID}`,
};

export function createCharge(data: CreateChargeData): Promise<CreateChargeResponse> {
    return httpClient.post(ENDPOINTS.CREATE, data);
}

export function getChargeInfo(sourceID: string): Promise<Charge> {
    return httpClient.get(ENDPOINTS.GET(sourceID));
}
